import { render } from "./switch.vue?vue&type=template&id=075bed70&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import "./switch.vue?vue&type=style&index=0&id=075bed70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075bed70"]])

export default __exports__